import 'antd/es/date-picker/style/index'

import dateFnsGenerateConfig from 'rc-picker/es/generate/dateFns' // Changed to /es/ and default import
import generatePicker from 'antd/es/date-picker/generatePicker'

const DatePicker = generatePicker(dateFnsGenerateConfig)

export default DatePicker
